import { Box } from '@mui/material';
import DistanceFilter from 'components/FilterFields/DistanceFilter';
import TargetSuburbFilter from 'components/FilterFields/TargetSuburbFilter';
import PropTypes from 'prop-types';

const RadiusFilters = (props) => (
    <Box>
        <Box sx={{display: 'flex', justifyContent: 'space-between'}}>
            <DistanceFilter
                comparableType={props.comparableType}
                containerStyle={{
                    '& .MuiTypography-textError2': {
                        position: 'absolute',
                        top: '40px',
                    }
                }}
            />
            <TargetSuburbFilter comparableType={props.comparableType}/>
        </Box>
    </Box>
);

RadiusFilters.propTypes = {
    comparableType: PropTypes.string,
};

export default RadiusFilters;